import { render, staticRenderFns } from "./ProfileSummary.vue?vue&type=template&id=361f6f9b"
import script from "./ProfileSummary.vue?vue&type=script&lang=js"
export * from "./ProfileSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports